var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var d3 = require('d3');

function IndexConceptsPerformance(el) {
    var $el = $(el),
        metaData = JSON.parse($el.attr('data-metadata')),
        conceptData = JSON.parse($el.attr('data-chart')),
        chartDiv = '#performance-chart-'+metaData['concept_slug'],
        conceptName = metaData['concept_name'],
        benchmarkName = metaData['benchmark_name'];

    var parseTime = d3.timeParse('%Y-%m-%d');

    var formatDate = d3.timeFormat('%m-%d-%Y');

    conceptData.forEach(function(d) {
        d.date = parseTime(d['date']);
        d.concept = +d['return_value'];
        d.benchmark = +d['benchmark_return'];
    })

    conceptData.sort(function(a,b) {
        return new Date(a.date) - new Date(b.date);
    })

    var availableDates = [];
    conceptData.forEach(function(d) {
        availableDates.push(d.date);
    })

    var groupValuesByX = d3.nest()
        .key(function(d) {return d.date})
        .object(conceptData)

    var margin = {top: 5, right: 50, bottom: 170, left: 60},
        margin2 = {top: 450, right: 50, bottom: 50, left: 60}
        width = 1100 - margin.right - margin.left,
        height = 550 - margin.bottom - margin.top,
        height2 = 550 - margin2.bottom - margin2.top;

    var x = d3.scaleTime().range([0, width]),
        y = d3.scaleLinear().range([height, 0]),
        x2 = d3.scaleTime().range([0, width]),
        y2 = d3.scaleLinear().range([height2, 0]);

    var conceptMin = d3.min(conceptData, function(d) {return d.concept}),
        benchmarkMin = d3.min(conceptData, function(d) {return d.benchmark}),
        conceptMax = d3.max(conceptData, function(d) {return d.concept}),
        benchmarkMax = d3.max(conceptData, function(d) {return d.benchmark});

    x.domain(d3.extent(conceptData, function(d) {return d.date; }));
    y.domain([(d3.min([conceptMin, benchmarkMin]) -1), (d3.max([conceptMax, benchmarkMax]) + 1)]);
    x2.domain(x.domain());
    y2.domain(y.domain());

    var xAxis = d3.axisBottom(x),
        xAxis2 = d3.axisBottom(x2),
        yAxis = d3.axisLeft(y).ticks(10).tickSizeInner(-width).tickFormat(function(d) {return d + "%"} );

    var brush = d3.brushX()
        .extent([[0, 0], [width, height2]])
        .on('brush', brushed);

    var zoom = d3.zoom()
        .scaleExtent([1, Infinity])
        .translateExtent([[0, 0], [width, height]])
        .extent([[0, 0], [width, height]])
        .on('zoom', zoomed)
        .filter(function() { return d3.event.ctrlKey || d3.event.type === "dblclick" || d3.event.type === "mousedown"});

    var benchmarkLine = d3.line()
        .x(function(d) {return x(d.date)})
        .y(function(d) {return y(d.benchmark)});

    var conceptLine = d3.line()
        .x(function(d) {return x(d.date)})
        .y(function(d) {return y(d.concept)});

    var benchmarkLine2 = d3.line()
       .x(function(d) {return x2(d.date)})
       .y(function(d) {return y2(d.benchmark)});

    var conceptLine2 = d3.line()
        .x(function(d) {return x2(d.date)})
        .y(function(d) {return y2(d.concept)});

    var svg = d3.select(chartDiv).append("div")
        .classed("svg-container", true)
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("viewBox", "0 0 " + (width + margin.right + margin.left) + " " + (height + margin.bottom + margin.top))
        .classed("svg-content-responsive", true);
                
    var focus = svg.append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var context = svg.append("g")
        .attr("transform","translate("+margin2.left+","+margin2.top+")");

    focus.append("g")
        .attr("transform", "translate(0," + height + ")")
        .attr("class", "axis axis--x")
        .call(xAxis);
    
    focus.append("g")
        .attr("class", "axis y")
        .call(yAxis);

    focus.append("path")
        .data([conceptData])
        .attr("class", "benchmark line b-line")
        .attr("id", "b-line-"+metaData['concept_slug'])
        .attr("stroke", "#e34711")
        .attr("d", benchmarkLine)
      
    focus.append("path")
        .data([conceptData])
        .attr("class", "concept line c-line")
        .attr("id", "c-line-"+metaData['concept_slug'])
        .attr("stroke", "#1a59c4")
        .attr("d", conceptLine)

    svg.append("defs").append("clipPath")
        .attr("id","clip-"+metaData['concept_slug'])
        .append("rect")
        .attr("width",width)
        .attr("height",height);

    focus.select("#b-line-"+metaData['concept_slug']).attr("clip-path","url(#clip-"+metaData['concept_slug']+")");
    focus.select("#c-line-"+metaData['concept_slug']).attr("clip-path","url(#clip-"+metaData['concept_slug']+")");

    context.append("path")
           .data([conceptData])
           .attr("class", "benchmark line")
           .attr("stroke", "#e34711")
           .attr("d", benchmarkLine2)

    context.append("path")
           .data([conceptData])
           .attr("class", "concept line")
           .attr("stroke", "#1a59c4")
           .attr("d", conceptLine2)

    context.append("g")
           .attr("transform", "translate(0," + height2 + ")")
           .attr("class", "axis")
           .call(xAxis2);

    var contextBrush = context.append("g")
           .attr("class", "brush")
           .call(brush);

   var brushHandlePath = function(d) {
        var e = +(d.type == "e"),
            x = e ? 1 : -1,
            y = height2 + 10;

        return "M" +
                0.5 * x +
                "," +
                y +
                "A6,6 0 0 " +
                e +
                " " +
                6.5 * x +
                "," +
                (y + 6) +
                "V" +
                (2 * y - 6) +
                "A6,6 0 0 " +
                e +
                " " +
                0.5 * x +
                "," +
                2 * y +
                "Z" +
                "M" +
                2.5 * x +
                "," +
                (y + 8) +
                "V" +
                (2 * y - 8) +
                "M" +
                4.5 * x +
                "," +
                (y + 8) +
                "V" +
                (2 * y - 8)
    }

    var brushHandle = contextBrush.selectAll(".handle--custom")
        .data([{type: "w"}, {type: "e"}])
      .enter().append("path")
        .attr("class", "handle--custom")
        .attr("stroke", "#000")
        .attr("cursor", "ew-resize")
        .attr("d", brushHandlePath);

    var rectOverlay = svg.append("rect")
        .attr("cursor", "move")
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .attr("class", "zoom")
        .attr("width", width)
        .attr("height", height)
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
        .call(zoom)
        .on("mousemove", focusMouseMove)
        .on("mouseover", focusMouseOver)
        .on("mouseout", focusMouseOut);

    var mouseLine = focus.append("path") 
        .attr("class", "mouse-line")
        .attr("stroke", "#D3D3D3")
        .attr("stroke-dasharray", "5, 5")
        .attr("stroke-width", 2)
        .attr("opacity", "0");

    var tooltip = focus
        .append("g")
        .attr("class", "tooltip-wrapper")
        .attr("display", "none");

    var tooltipBackground = tooltip.append("rect").attr("fill", "#fff").attr("stroke", "#D6D6D6").attr("rx", "5").attr("ry", "5").attr("stroke-width", "1px")

    var tooltipText = tooltip.append("text");

    contextBrush.call(brush.move, [0, width])

    focus.append("text")
        .attr("transform", "translate(" + width / 2 + " ," + (height + margin.top + 40) + ")")
        .style("text-anchor", "middle")
        .style("font-size", "16px")
        .style("font-family", "FFDINStdCondensedMedium")
        .style("fill", "#4a4a4a")
        .text("Date (Beginning " + concept_date + ")");

    focus.append("text")
        .attr("text-anchor", "middle")
        .attr("transform", "translate(" + (-margin.left + 20) + "," + height / 2 + ")rotate(-90)")
        .style("font-size", "16px")
        .style("font-family", "FFDINStdCondensedMedium")
        .style("fill", "#4a4a4a")
        .text("Returns");

    function brushed() {
        if (d3.event.sourceEvent && d3.event.sourceEvent.type === "zoom") return; // ignore brush-by-zoom
        tooltip.attr("display", "none");
        focus.selectAll(".tooltip-line-circles").remove();
        mouseLine.attr("opacity", "0");
        var s = d3.event.selection || x2.range();
        x.domain(s.map(x2.invert, x2));
        focus.select(".b-line").attr("d", benchmarkLine);
        focus.select(".c-line").attr("d", conceptLine);
        focus.select(".axis--x").call(xAxis);
        svg.select(".zoom").call(zoom.transform, d3.zoomIdentity.scale(width / (s[1] - s[0])).translate(-s[0], 0));
        brushHandle.attr("display", null).attr("transform", function(d, i) { 
            return  "translate(" + s[i] +","+ (-height2 - 18) + ")"
        });
    }

    function zoomed() {
        if (d3.event.sourceEvent && d3.event.sourceEvent.type === "brush") return; // ignore zoom-by-brush
        tooltip.attr("display", "none");
        focus.selectAll(".tooltip-line-circles").remove();
        mouseLine.attr("opacity", "0");
        var t = d3.event.transform;
        x.domain(t.rescaleX(x2).domain());
        focus.select(".b-line").attr("d", benchmarkLine);
        focus.select(".c-line").attr("d", conceptLine);
        focus.select(".axis--x").call(xAxis);
        var brushSelection = x.range().map(t.invertX, t);
        context.select(".brush").call(brush.move, brushSelection);
        brushHandle.attr("display", null).attr("transform", function (d, i) { return "translate(" + brushSelection[i]+ "," + (-height2 - 18) + ")"});
    }

    function focusMouseMove() {
        tooltip.attr("display", null);
        var mouse = d3.mouse(this);
        var dateOnMouse = x.invert(mouse[0]);
        var nearestDateIndex = d3.bisect(availableDates, dateOnMouse);
        var d0 = new Date(availableDates[nearestDateIndex - 1]);
        var d1 = new Date(availableDates[nearestDateIndex]);
        var closestDate;
        if (d0 < x.domain()[0]) {
          closestDate = d1;
        } else if (d1 > x.domain()[1]) {
          closestDate = d0;
        } else {
          closestDate = (dateOnMouse - d0 > d1 - dateOnMouse) ? d1 : d0;
        }

        var nearestDateYValues = groupValuesByX[new Date(closestDate)];
        var nearestDateXCord = x(new Date(closestDate));

        mouseLine.attr('d', 'M ' + nearestDateXCord +' 0 V '+ y(d3.min([conceptMin, benchmarkMin]) -1)).attr("opacity", "1");
        tooltipText.selectAll(".tooltip-text-line").remove();
        focus.selectAll(".tooltip-line-circles").remove();
        
        tooltipText.append("tspan")
            .attr("class", "tooltip-text-line")
            .attr("x", "10")
            .attr("y", "5")
            .attr("dy", "14px")
            .style("font-size", "16px")
            .style("fill", "#4a4a4a")
            .text(formatDate(closestDate));

        focus.append("circle")
            .attr("class", "tooltip-line-circles")
            .attr("r", 5)
            .attr("fill", "#1a59c4")
            .attr("cx", nearestDateXCord)
            .attr("cy", y(nearestDateYValues[0]['concept']));

        focus.append("circle")
            .attr("class", "tooltip-line-circles")
            .attr("r", 5)
            .attr("fill", "#e34711")
            .attr("cx", nearestDateXCord)
            .attr("cy", y(nearestDateYValues[0]['benchmark']));

        tooltipText.append("tspan")
            .attr("class", "tooltip-text-line")
            .attr("x", "10")
            .attr("dy", '20px')
            .attr("font-family", "FFDINStdBold")
            .attr("fill", "#1a59c4")
            .text(metaData['concept_name'] +": " + nearestDateYValues[0]['concept'].toFixed(2)+"%");

        tooltipText.append("tspan")
            .attr("class", "tooltip-text-line")
            .attr("x", "10")
            .attr("dy", '20px')
            .attr("font-family", "FFDINStdBold")
            .attr("fill", "#e34711")
            .text(metaData['benchmark_name']+": " + nearestDateYValues[0]['benchmark'].toFixed(2)+"%");

        var tooltipWidth = tooltipText.node().getBBox().width;
        var tooltipHeight = tooltipText.node().getBBox().height;
        var rectOverlayWidth = rectOverlay.node().getBBox().width;
        tooltipBackground.attr("width", tooltipWidth + 20).attr("height", tooltipHeight + 10);
        if (nearestDateXCord + tooltipWidth >= rectOverlayWidth) {
          tooltip.attr("transform", "translate(" + (nearestDateXCord - tooltipWidth - 20) + "," + mouse[1] + ")");
        } else {
          tooltip.attr("transform", "translate(" + (nearestDateXCord + 10) + "," + mouse[1] + ")");
        }
    }

    function focusMouseOver() {
        mouseLine.attr("opacity", "1");
        tooltip.attr("display", null);
    }

    function focusMouseOut() {
        mouseLine.attr("opacity", "0");
        tooltip.attr("display", "none");
        focus.selectAll(".tooltip-line-circles").remove();
    }

}

module.exports = IndexConceptsPerformance;



